import HighchartsReact from 'highcharts-react-official'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from 'components/utils/colors'

const ChartWrapper = ({ className, containerProps, forwardRef, ...rest }) => {
  // fix for https://github.com/highcharts/highcharts/issues/22148
  // styled components don't work here
  return (
    <div style={{ height: '100%' }}>
      <HighchartsReact
        containerProps={{
          ...containerProps,
          className,
          style: {
            width: '100%',
            height: '100%',
          },
        }}
        ref={forwardRef}
        {...rest}
      />
    </div>
  )
}

ChartWrapper.propTypes = {
  containerProps: PropTypes.object,
  forwardRef: PropTypes.object,
}

export const tooltipStyle = {
  borderRadius: 5,
  borderSize: 1,
  borderColor: colors.secondary20,
  backgroundColor: colors.secondary20,
  style: {
    color: 'white',
    width: 'auto', // to prevent wrapping lines. See https://github.com/highcharts/highcharts/issues/10195
  },
  shadow: false,
}

const StyledHighcharts = styled(ChartWrapper)`
  .highcharts-container {
    overflow: visible !important;
    width: 100% !important;

    .highcharts-no-data {
      font-family: 'Open Sans';
    }
  }

  .highcharts-root {
    width: 100% !important;
    font-family: 'Open Sans' !important;
  }
`

StyledHighcharts.propTypes = {
  containerProps: PropTypes.object,
  forwardRef: PropTypes.object,
}

export default StyledHighcharts
